import teamRequestsModalApproveAllConfirmComponent from './teamRequestsModalApproveAllConfirm.component';

let teamRequestsModalApproveAllConfirmModule = angular.module('vacations-absences.teamRequestsModalApproveAllConfirm', [])

.component('teamRequestsModalApproveAllConfirm', teamRequestsModalApproveAllConfirmComponent)

.name;

export default teamRequestsModalApproveAllConfirmModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAllConfirm/teamRequestsModalApproveAllConfirm.js